// extracted by mini-css-extract-plugin
export var button = "address-add-module--button--sJI8f";
export var form = "address-add-module--form--Bxt9X";
export var globalError = "address-add-module--global-error--LP1VT";
export var labelInput = "address-add-module--label-input--rENfj";
export var noAddressesMessage = "address-add-module--no-addresses-message--6Zwq3";